<template>
  <div>
    <Header />
    <Project3Details />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer";
import Header from "../components/Header"
import Project3Details from "../components/Project3Details";
import Contact from "../components/Contact";

export default {
  name: "Project2",
  components: {
    Header,
    Footer,
    Project3Details,
    Contact,
  }
};
</script>
